import { Navigate, useLocation, type RouteObject } from "react-router";

/** Recover /start links in already-delivered emails, preserving attribution. */
function LegacyEmailStartRedirect() {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: "/search", search, hash }} replace />;
}

/**
 * Retired prototype routes (FAI-147).
 *
 * `/portal` (PostPurchasePortal) showed every signed-in visitor a countdown
 * that always read "42 Days Remaining" and Harris-portal filing steps; `/payment`
 * (PaymentFlow) was the matching prototype checkout timeline. Neither was driven
 * by the CIE season helpers, so both are retired. Old links and bookmarks land
 * on `/dashboard`, which routes a signed-in homeowner to Appeal HQ and everyone
 * else to the homepage. Deadlines are shown only where the CIE derives them.
 */
export const RETIRED_ROUTE_REDIRECTS: RouteObject[] = [
  { path: "/start", element: <LegacyEmailStartRedirect /> },
  { path: "/portal", element: <Navigate to="/dashboard" replace /> },
  { path: "/payment", element: <Navigate to="/dashboard" replace /> },
];
